import clsx from 'clsx';
import { Popover, PopoverButton, PopoverPanel } from '@headlessui/react';

type Props = {
    btn: React.ReactNode;
    body: string;
    panelClassName?: string;
}
export default function ClickableTooltip({ body, btn, panelClassName }: Props) {
    return (
        <Popover className="inline-block leading-[0px]">
            <PopoverButton className="btn-text data-[open]:text-gray-900" title={body}>{btn}</PopoverButton>
            <PopoverPanel
                anchor={{
                    to: "bottom",
                    gap: 12,
                    padding: 14,
                }}
                transition
                className={clsx(
                    'p-1.5 rounded-sm bg-white shadow-md border text-sm text-gray-700 transition duration-200 ease-in-out data-[closed]:-translate-y-3 data-[closed]:opacity-0',
                    panelClassName,
                )}
            >
                <div className='max-w-64'>
                    {body}
                </div>
            </PopoverPanel>
        </Popover>
    )
}
